import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/shadcn/table";
import { useQuery } from "react-query";
import { queryKey } from "@/store/queryKeys.ts";
import { constants } from "@/constants";
import { useParams } from "react-router-dom";
import Loading from "@/components/Loading";
import {useTranslation} from "react-i18next";

export function LeadsTable() {
  const { chatbotID } = useParams();
  const {t} = useTranslation();

  let leadsQuery = useQuery(queryKey.chatbotLeads(), async function () {
    let res = await fetch(
      `${constants.url.API_PREFIX}chatbot/${chatbotID}/leads`,
    );
    return res.json();
  });

  if (leadsQuery.isLoading || !leadsQuery.data?.list) {
    return <Loading />;
  }

  let fields = leadsQuery.data.fields ? Object.entries(leadsQuery.data.fields) : [];

  return (
    <Table>
      <TableCaption>A list of recent leads</TableCaption>
      <TableHeader>
        <TableRow>
          {fields.map(([key, value], i) => (
            <TableHead key={i}>{key}</TableHead>
          ))}
          <TableHead>{t("created_at")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {leadsQuery.data.list.map((row: any, i: number) => (
          <TableRow key={i}>
            {fields.map(([key, value], j) => {
              let val = row.visitor_data[key];
              return (
                <TableCell key={j} className="font-medium">{val ? val : ""}</TableCell>
              );
            })}

            <TableCell className="font-medium">
              {new Date(row.updated_at * 1000).toLocaleString()}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
      </TableFooter>
    </Table>
  );
}
